// Documents List Component
// Displays uploaded documents with download links

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Download } from 'lucide-react';

const DocumentsList = ({ fileUrls }) => {
  if (!fileUrls || fileUrls.length === 0) return null;

  return (
    <Card className="border-slate-200" data-testid="documents-list-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <FileText className="w-5 h-5 text-slate-600" />
          Uploaded Documents ({fileUrls.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {fileUrls.map((url, index) => (
            <a
              key={index}
              href={`${process.env.REACT_APP_BACKEND_URL}${url}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors"
              data-testid={`document-${index}`}
            >
              <FileText className="w-5 h-5 text-slate-500" />
              <span className="flex-1 text-slate-700 font-medium">Document {index + 1}</span>
              <Download className="w-4 h-4 text-slate-400" />
            </a>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default DocumentsList;
